import React from 'react';

const ThreeDButton = ({ text, selected, onClick, paddingX = 4, paddingY = 1 }) => {
  const paddingClass = `px-${paddingX} py-${paddingY}`;
  const baseClasses = [
    'rounded-md',
    'font-bold',
    'transition-all',
    'duration-200',
    'cursor-pointer',
    paddingClass,
    selected
      ? 'bg-[#032a61] text-white shadow-inner shadow-black/60'
      : 'bg-white text-[#032a61] shadow-md shadow-black/30'
  ].join(' ');

  return (
    <button className={baseClasses} onClick={onClick}>
      {text}
    </button>
  );
};

export default ThreeDButton;
